<template>
  <div class="portal-login-root">
    <div class="portal-login-card glassmorphism">
      <h2>商家端登录</h2>
      <el-form ref="formRef" :model="form" :rules="rules" @keyup.enter="handleLogin">
        <el-form-item prop="username">
          <el-input v-model="form.username" placeholder="商家账号" clearable />
        </el-form-item>
        <el-form-item prop="password">
          <el-input v-model="form.password" type="password" placeholder="密码" show-password />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="loading" @click="handleLogin" style="width: 100%;">登录商家端</el-button>
        </el-form-item>
        <el-form-item style="margin-bottom: 8px;">
          <div class="demo-login-wrap">
            <el-tooltip content="演示账号一键登录" placement="top">
              <el-button circle class="demo-icon-btn" @click="loginWithDemo" :loading="loading">
                <el-icon><UserFilled /></el-icon>
              </el-button>
            </el-tooltip>
          </div>
        </el-form-item>
      </el-form>
      <div class="link-row">
        <el-link type="info" @click="goUserLogin">用户登录</el-link>
        <el-link type="warning" @click="goAdminLogin">管理端登录</el-link>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage, ElNotification } from 'element-plus'
import { authAPI } from '../api/auth'

const router = useRouter()
const formRef = ref(null)
const loading = ref(false)
const form = reactive({ username: '', password: '' })
const rules = {
  username: [{ required: true, message: '请输入商家账号', trigger: 'blur' }],
  password: [{ required: true, message: '请输入密码', trigger: 'blur' }]
}

const handleLogin = async () => {
  if (!formRef.value) return
  const valid = await formRef.value.validate().catch(() => false)
  if (!valid) return

  loading.value = true
  try {
    const response = await authAPI.login(form.username, form.password)
    const { token, user, success, message, data } = response.data || {}
    const finalToken = token || data?.token
    const finalUser = user || data?.user
    const isSuccess = success !== false && finalToken && finalUser

    if (!isSuccess) {
      ElMessage.error(message || '登录失败，请检查账号密码')
      return
    }

    localStorage.setItem('portalRole', 'MERCHANT')
    localStorage.setItem('token', finalToken)
    localStorage.setItem('user', JSON.stringify(finalUser))

    ElNotification({
      title: '登录成功',
      message: `欢迎进入商家端，${finalUser.nickname || finalUser.username || form.username}`,
      type: 'success',
      duration: 1800,
    })
    router.push('/merchant')
  } catch (error) {
    ElMessage.error(error.response?.data?.message || error.message || '网络异常，请稍后再试')
  } finally {
    loading.value = false
  }
}

const loginWithDemo = async () => {
  form.username = 'admin'
  form.password = '123456'
  await handleLogin()
}

const goUserLogin = () => router.push('/login')
const goAdminLogin = () => router.push('/admin/login')
</script>

<style scoped>
.portal-login-root {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
.portal-login-card {
  width: 420px;
  max-width: 100%;
  padding: 28px;
  border-radius: 16px;
}
.portal-login-card h2 {
  margin: 0 0 18px;
  color: #fff;
  text-align: center;
}
.glassmorphism {
  background: rgba(35, 42, 77, 0.88);
  border: 1px solid rgba(163, 163, 255, 0.25);
  backdrop-filter: blur(16px);
}
.link-row {
  display: flex;
  justify-content: space-between;
}

.demo-login-wrap {
  width: 100%;
  display: flex;
  justify-content: center;
}

.demo-icon-btn {
  background: rgba(83, 124, 229, 0.14);
  border-color: rgba(83, 124, 229, 0.35);
  color: #cddcff;
}
</style>
